<form nz-form class="form">
  <div class="drawer-form-wrapper">
    <div
      class="behaviour-card-sec"
      *ngIf="caseParams && caseParams.case && caseParams.case.student">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ caseParams.case.student.firstName }}
          {{ caseParams.case.student.lastName }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"
              aria-label="Calendar"></svg-icon>
            {{ caseParams.case.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"
              aria-label="Supervisor"></svg-icon>
            {{ caseParams.case.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-18"
              aria-label="Male"></svg-icon>
            {{ caseParams.case.student.gender }}
          </p>
        </div>
      </div>
    </div>

    <!-- Dropdown for case behaviors -->
    <div class="select-wrapper mb-24">
      <h3 class="title">Select behavior</h3>
      <nz-select
        class="w-50"
        id="caseBehavior"
        [(ngModel)]="selectedBehaviorId"
        [ngModelOptions]="{ standalone: true }"
        [nzPlaceHolder]="'Select a behavior'"
        (ngModelChange)="onBehaviorChange($event)">
        <nz-option
          *ngFor="let behavior of caseBehaviors"
          [nzLabel]="behavior.name ?? ''"
          [nzValue]="behavior.id">
        </nz-option>
      </nz-select>
    </div>
    <app-data-sheet
      class="mt-12"
      [caseParams]="dataSheetParams"
      [behaviorId]="selectedBehaviorId"
      *ngIf="isDataSheet"></app-data-sheet>
    <ng-template #nodata>
      <app-no-data
        [title]="'No Behavior'"
        [desc]="'No Behavior Defined'"
        [icon]="'/assets/icon/icon-face-happy.svg'">
      </app-no-data>
    </ng-template>
  </div>
  <div class="display-flex justify-content-between drawer-footer">
    <div class="footer-left">
      <button nz-button type="button" nzType="default" (click)="onCancel()">
        Cancel
      </button>
    </div>
  </div>
</form>
